// ============================================================================
// KNIGHT'S TOUR - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'knights-tour',
  name: "Knight's Tour",
  category: 'Backtracking',
  complexity: {
    time: 'O(8^(n*n))',
    space: 'O(n^2)'
  },
  description: "Knight's Tour finds a sequence of moves for a knight to visit every square on a chessboard exactly once using backtracking."
};
export type MetaType = typeof meta;
